import { __extends, __assign, __rest } from 'tslib';
import React__default from 'react';
import ReactModal from 'react-modal';
import clsx from 'clsx';
import { propTypes, defaultProps } from './Modal.types.js';
import styles from './Modal.module.scss.js';

var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.assignClassName = function (base, propCls) {
            if (typeof propCls === 'object') {
                return __assign(__assign({}, propCls), { base: clsx(base, propCls.base) });
            }
            return clsx(base, propCls);
        };
        return _this;
    }
    Modal.prototype.componentDidUpdate = function (prevProps) {
        var wasOpened = !prevProps.isOpen && this.props.isOpen;
        var wasClosed = prevProps.isOpen && !this.props.isOpen;
        if (wasOpened) {
            document.body.classList.add(styles.Body___noScroll);
        }
        if (wasClosed) {
            document.body.classList.remove(styles.Body___noScroll);
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        document.body.classList.remove(styles.Body___noScroll);
    };
    Modal.prototype.render = function () {
        var _a = this.props, className = _a.className, overlayClassName = _a.overlayClassName, hasBackgroundBlur = _a.hasBackgroundBlur, headerComponent = _a.headerComponent, children = _a.children, footerComponent = _a.footerComponent, reactModalProps = __rest(_a, ["className", "overlayClassName", "hasBackgroundBlur", "headerComponent", "children", "footerComponent"]);
        return (React__default.createElement(ReactModal, __assign({ className: this.assignClassName(styles.Modal, className), overlayClassName: this.assignClassName(clsx(styles.Overlay, !!hasBackgroundBlur && styles.Overlay___blurred), overlayClassName) }, reactModalProps),
            headerComponent,
            children,
            footerComponent));
    };
    Modal.displayName = 'Modal';
    Modal.propTypes = propTypes;
    Modal.defaultProps = __assign({}, defaultProps);
    return Modal;
}(React__default.Component));

export { Modal as default };
